<template>
<v-layout row wrap my-5>
    <v-flex xs12 md8 offset-md2>
        <p class="d-block pa-5 display-4 text-xs-center">404 Not Found</p>
    </v-flex>
</v-layout>
</template>

<script>
export default {
    name: 'notFound'
}
</script>
